import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./recentTransaction.css";
import { useDispatch } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";

// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> >>>>>>>>>>>

import IsLoading from "../../../../../IsLoading.jsx";
import FilterRecentTrans from "../../inventory_comps/filters/FilterRecentTrans.jsx";
import ExportPDFButton from "../../inventory_comps/exports/RecentTransPDFExport.jsx";
import ExportExcelJSButton from "../../inventory_comps/exports/RecentTransExcelExport";
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

// import from MUI

import ReceiptIcon from "@mui/icons-material/Receipt";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PrintIcon from "@mui/icons-material/Print";
import FlightIcon from "@mui/icons-material/Flight";
import PlaceIcon from "@mui/icons-material/Place";
import AppsOutlinedIcon from "@mui/icons-material/AppsOutlined";
import AddIcon from "@mui/icons-material/Add";
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";
import { TerminalReprinting } from "../printings_warehouse/PrintSalesReciept.jsx";
// image imports
let transactionsData;
export default function RecentTransaction({ breadcrumbs, setAlert }) {
  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef });
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [openReciept, setOpenReciept] = useState(false);
  const [soldPayload, setSoldPayload] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [changeview, setChangeView] = useState("");
  const [recentTransFilterOpen, setrecentTransFilterOpen] = useState(false);
  const [currentTab, setCurrentTab] = useState("");
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const { registerData } = useSelector((state) => state.terminalActions);
  const data = useSelector(
    (state) => state.clientFunction?.queue?.clientData?.clientInfo,
  );
  console.log("registerData: ", registerData);
  // Paginations Functions
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [openLimit, setOpenLimit] = useState(false);
  const totalPages = Math.ceil(transactionsData?.length / rowsPerPage);
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentRows = transactionsData?.slice(start, end);

  // /////////////////////////////////////////////////////////
  // Redux functions for sub-navigation
  // /////////////////////////////////////////////////////////

  function handlePrint(data) {
    // dispatch(Action.dispatchPrintData({ data }));
    // navigate(`/clients/${id}}/account/data_printing`);
    window.open(`/clients/${id}/account/data_printing`, "_blank");
  }

  // ////////////////////////////////////////////////////////////
  function getPagination(current, total) {
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    if (current <= 4) {
      return [1, 2, 3, 4, 5, "...", total];
    }

    if (current >= total - 3) {
      return [1, "...", total - 4, total - 3, total - 2, total - 1, total];
    }

    return [1, "...", current - 1, current, current + 1, "...", total];
  }

  const printElement = (id) => {
    const element = document.getElementById(id);
    if (!element) return;

    const printWindow = window.open("", "_blank", "width=900,height=650");

    printWindow.document.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
          body { font-family: Arial; padding: 20px; }
        </style>
      </head>

      <body>
        ${element.innerHTML}

        <script>
          window.onload = function () {
            window.print();

            // close after print dialog finishes
            window.onafterprint = function () {
              window.close();
            };
          };
        </script>
      </body>
    </html>
  `);

    printWindow.document.close();
  };

  async function apiGetSales() {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/register/${registerData?.registerId}/client/${registerData?.clientId}/getRegSoldItem`,
      )
      .then((response) => {
        transactionsData = response.data.regTransactions;
        console.log("transactionsData: ", transactionsData);
        if (response.data.status === 201) {
          setLoading(false);
          setAlert({
            message: `${response.data.message}`,
            type: "added",
          });
        } else {
          setAlert({
            message: `${response.data.message}`,
            type: "error",
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        setAlert({
          message: `error: something went wrong! ${error}`,
          type: "error",
        });
        console.log(error?.code || "REQUEST_FAILED");
        setLoading(false);
      });
  }
  // //////////////////////////////////////////////////////////////////////////
  // COMPONENTS OF recentTrans PAGE
  // //////////////////////////////////////////////////////////////////////////

  function switchView() {
    switch (changeview) {
      case "grid":
        return <CardView currentRows={currentRows} />;
      case "table":
        return <TableView currentRows={currentRows} />;
      default:
        return <TableView currentRows={currentRows} />;
    }
  }
  function TableView({ currentRows }) {
    return (
      <div className="recentTrans">
        <table className="fx-cl spacem">
          <thead className="fx-cl spacem">
            <tr>
              <th>Invoice No.</th>
              <th>&nbsp;</th>
              <th>Customer</th>
              <th>Method</th>
              <th>Items</th>
              <th>Received</th>
              <th>Change</th>
              <th>Discount</th>
              <th>Total paid</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody className="fx-cl spacem">
            {currentRows?.map((item, index) => {
              // Parse the date strings into readable formats
              const rowDate = item.date
                ? new Date(item.date).toLocaleDateString()
                : "";
              const rowTime = item.timeInn
                ? new Date(item.timeInn).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : "";

              return (
                <tr key={item.registerId}>
                  {/* Optional: Row Index Number */}
                  {/* <td>{index + 1}</td> */}

                  <td>{item?.saleId}</td>
                  <td className="fw600">
                    <button
                      className=" fx-ac spacem"
                      id="salesBtnReciept"
                      onClick={(e) => {
                        e.stopPropagation(); // stop bubbling to document
                        setOpenReciept(true);
                        setSoldPayload(item);
                      }}
                    >
                      <ReceiptIcon fontSize="small" />
                      <span>Receipt</span>
                    </button>
                  </td>
                  <td>
                    <strong>{item.customer_name}</strong>
                  </td>
                  <td>{(item?.payment.method).toUpperCase()}</td>
                  <td>{item.soldItems?.length}</td>
                  <td className="fw600">
                    ₦{item.totals?.cash?.toLocaleString()}
                  </td>
                  <td className="fw600">
                    ₦{item.totals?.change?.toLocaleString()}
                  </td>
                  <td className="fw600">
                    ₦{item.totals?.discount?.amount?.toLocaleString()}
                  </td>
                  <td className="fw600">
                    ₦{item.totals?.subtotal?.toLocaleString()}
                  </td>
                  <td className="fw600">{rowTime}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  function CardView({ currentRows }) {
    return (
      <div className="recentTransCardGrid g g4 space2">
        {currentRows?.map((item) => (
          <div key={item.invoiceNo} className="recentTransGridCard">
            {/* Header */}
            <div className="cardHeader">
              <img alt="customer" className="avatar" />

              <div className="cardInfo">
                <h4>{item.customerName}</h4>
                <p>Invoice #{item.invoiceNo}</p>

                <div className="ratingRow">
                  <span className="rating">
                    ⭐ {item.paymentStatus === "Paid" ? "5.0" : "4.0"}
                  </span>
                  <span className="location">📍 {item.date}</span>
                </div>

                <small>{item.totalItems} items</small>
              </div>
            </div>

            {/* Tags */}
            <div className="tags">
              <span>Total</span>
              <span>Paid</span>
              <span>+{item.totalItems}</span>
            </div>

            {/* Footer */}
            <div className="cardFooter">
              <div className="price">
                ₦{item.totalAmount?.toLocaleString()}
                <small> / sale</small>
              </div>

              <button className="cardBtn">View Sale</button>
            </div>
          </div>
        ))}
      </div>
    );
  }

  useEffect(() => {
    apiGetSales();
  }, [registerData?.registerId, data?.clientId]);

  return (
    <>
      {loading && <IsLoading />}

      {transactionsData?.length > 0 ? (
        <div
          className="recentTransCompContainer"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div className="reprintModal">
            {openReciept && (
              <TerminalReprinting
                contentRef={contentRef}
                soldPayload={soldPayload}
                setModalOpen={setOpenReciept}
              />
            )}
          </div>
          <div className="fx-cl space2">
            <div className="recentTrans_headings fx-jb space4">
              <div className="fx-cl">
                <h2 style={{ textTransform: "capitalize" }}>
                  Recent Transactions
                </h2>
                <p style={{ fontSize: "1.2rem" }}>
                  Here is a list of recentTrans you have made
                </p>
              </div>
              <div className="fx-ac fx-jb spacem">
                <div className=" fx-ac spacem">
                  <div>
                    {changeview === "grid" ? (
                      <button
                        className="iconBtn"
                        onClick={() => setChangeView("table")}
                      >
                        <ListAltIcon fontSize="large" />
                      </button>
                    ) : (
                      <button
                        className="iconBtn"
                        onClick={() => setChangeView("grid")}
                      >
                        <AppsOutlinedIcon fontSize="large" />
                      </button>
                    )}
                  </div>
                  <button
                    className="iconBtn printingBtn"
                    onClick={() =>
                      handlePrint({
                        currentRows: currentRows,
                        tab: currentTab,
                      })
                    }
                  >
                    <PrintIcon fontSize="large" />
                  </button>
                  <ExportPDFButton currentRows={currentRows} />
                </div>

                <div className="fx-ac space1">
                  <ExportExcelJSButton currentRows={currentRows} />
                </div>
              </div>
            </div>

            <div className="recentTrans_main">
              <div className="fx-cl space2">
                <div className="fx-cl spacem">
                  <div
                    className="fx-ac fx-jb space2"
                    style={{ fontSize: "1.2rem" }}
                  >
                    <span className="fx-ac spacem">
                      <strong className="fx-jc" style={{ color: "#3a84f8" }}>
                        Display:
                      </strong>
                      <span>
                        {transactionsData?.length === 0
                          ? "0 to 0 of 0 entries"
                          : `${start + 1} to ${Math.min(
                              end,
                              transactionsData?.length,
                            )} of ${transactionsData?.length} entries`}
                      </span>
                    </span>
                    <div className="recentTrans_entries-info fx-ac spacem">
                      <h4>Rows</h4>
                      <div className="recentTrans-page-limit">
                        <button
                          className="recentTrans-page-limit-btn"
                          onClick={() => setOpenLimit(!openLimit)}
                        >
                          {rowsPerPage} / page
                          <span className="recentTrans-page-limit-arrow">
                            ▾
                          </span>
                        </button>

                        {openLimit && (
                          <ul className="recentTrans-limit-dropdown">
                            {[10, 20, 50, 100, 200, 500, 1000].map((n) => (
                              <li
                                key={n}
                                className="recentTrans-limit-item"
                                onClick={() => {
                                  setRowsPerPage(n);
                                  setCurrentPage(1);
                                  setOpenLimit(false);
                                }}
                              >
                                {n} / page
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="recentTrans_row" id="printable">
                    {switchView()}
                  </div>
                  <div className="fx-jc">
                    <div className="recentTrans_pagination fx-ac space2">
                      <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((p) => p - 1)}
                      >
                        Previous
                      </button>
                      <div className="fx-ac">
                        {getPagination(currentPage, totalPages).map(
                          (page, i) =>
                            page === "..." ? (
                              <span key={i} className="dots">
                                …
                              </span>
                            ) : (
                              <button
                                key={i}
                                className={`recentTrans_jumpto ${
                                  currentPage === page ? "active" : ""
                                }`}
                                onClick={() => setCurrentPage(page)}
                              >
                                {page}
                              </button>
                            ),
                        )}
                      </div>

                      <button
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage((p) => p + 1)}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="fx-ac fx-jc" style={{ height: "70vh" }}>
          <h2 style={{ color: "#3a84f8" }}>No recent transactions found</h2>
        </div>
      )}
    </>
  );
}
